import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets.app/images/books-download-subscribe.svg'
import _imports_1 from '@/assets.app/images/books-download-free-trial.svg'


const _hoisted_1 = { class: "book-export container" }
const _hoisted_2 = { class: "book-export__container-wrapper" }
const _hoisted_3 = { class: "book-export__container" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "book-export__subscription-info"
}
const _hoisted_7 = {
  key: 1,
  class: "book-export__title"
}
const _hoisted_8 = {
  key: 2,
  class: "book-export__title"
}
const _hoisted_9 = {
  key: 3,
  class: "book-export__title"
}
const _hoisted_10 = {
  key: 4,
  class: "book-export__title"
}
const _hoisted_11 = { key: 5 }
const _hoisted_12 = { class: "book-export__subscription-info" }
const _hoisted_13 = {
  key: 0,
  class: "book-export__subscription-info"
}
const _hoisted_14 = { class: "book-export__start-trial-box" }
const _hoisted_15 = { class: "book-export__start-trial-header" }
const _hoisted_16 = { class: "book-export__start-trial-title" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "book-export__subscription-info" }
const _hoisted_19 = {
  key: 0,
  class: "book-export__subscription-info"
}
const _hoisted_20 = { class: "book-export__additional-info" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 1,
  class: "book-export__subscription-info"
}
const _hoisted_24 = {
  key: 2,
  class: "book-export__subscription-info"
}
const _hoisted_25 = { class: "book-export__info" }
const _hoisted_26 = {
  key: 3,
  class: "book-export__subscription-info"
}
const _hoisted_27 = {
  key: 4,
  class: "book-export__subscription-info"
}
const _hoisted_28 = { class: "book-export__info" }
const _hoisted_29 = { class: "book-export__additional-info" }
const _hoisted_30 = { key: 5 }
const _hoisted_31 = {
  key: 0,
  class: "book-export__library-link"
}
const _hoisted_32 = { class: "book-export__book-info" }
const _hoisted_33 = { class: "book-export__book-title" }
const _hoisted_34 = { class: "book-export__book-author" }
const _hoisted_35 = { class: "book-export__item book-export__pdf" }

import { computed, onBeforeMount, ref } from 'vue'
import { useWait } from '@/app/composables/useWait'
import { useRoute } from 'vue-router'

import BasePopup from '@/components/ui/BasePopup.vue'
import PdfDownloadLink from './PdfDownloadLink.vue'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'
import { Billing } from '@/models/interfaces'
import { BillingView } from '@/models/billing'
import { BookView } from '@/models/doc.book'
import { DocExportView } from '@/models/doc.export'
import Layout from '../Layout.vue'
import HeaderRoot from '@/app/components/header/Root.vue'
import KindleExportForm from '@/app/components/book/export/KindleExportForm.vue'
import BookExportLimit from '@/app/components/book/BookExportLimit.vue'
import BackLink from '@/app/components/BackLink.vue'
import { trialByPlan15535Treatment } from '@/services/ab/15535_trial_by_plan'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookExport',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props

const route = useRoute()
const wait = useWait()

const popup = ref<InstanceType<typeof BasePopup> | null>(null)

const billing = ref<BillingView | null>(null)
const view = ref<DocExportView | null>(null)

onBeforeMount(async () => {
  wait.start('Loading Book Export View')
  const response = await backend.getBilling()
  await _initView(response)
  wait.end('Loading Book Export View')

  setTimeout(
    () => {
      // Reload the page once in 5 minutes to get new doc export token.
      // This is for the case the user opens the page and leaves it for some time
      // before using the download button.
      if (route.name === 'book.export') {
        window.location.reload()
      }
    },
    5 * 60 * 1000,
  )
})

async function _initView(billingData: Billing): Promise<void> {
  billing.value = new BillingView(billingData)
  if (!props.doc.doc_export_stats) {
    try {
      await props.doc.getDocExportStats()
    } catch (error: any) {
      Sentry.captureException(error)
    }
  }
  if (props.doc.doc_export_stats) {
    view.value = new DocExportView(props.doc, billing.value as BillingView)
  }
}

function showEndTrialPopup(): void {
  popup.value?.show()
}

function hideEndTrialPopup(): void {
  popup.value?.hide()
}

const boxText = computed(() => {
  return trialByPlan15535Treatment()
    ? "Try Shortform's free trial without limits."
    : "Try Shortform's 5-day free trial without limits."
})

/**
 * Cancel subscription handler (for modal dialog).
 */
async function cancelTrial(): Promise<void> {
  try {
    hideEndTrialPopup()
    wait.start('Loading Book Export View')
    const response = await backend.cancelTrial()
    await _initView(response)
  } catch (error) {
    Sentry.captureException(error)
    alert('Error canceling trial')
  } finally {
    wait.end('Loading Book Export View')
  }
}

const isLoading = computed(() => {
  return wait.is('Loading Book Export View')
})

return (_ctx: any,_cache: any) => {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Layout, { hideMobileMenu: true }, {
    default: _withCtx(() => [
      _createVNode(HeaderRoot, { title: "Download" }),
      _createElementVNode("div", _hoisted_1, [
        (!__props.doc.isCurrentThread())
          ? (_openBlock(), _createBlock(BackLink, {
              key: 0,
              class: "book-export__backlink"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            (isLoading.value || !billing.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_loading_spinner)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (!view.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, " The PDF summary of this book is currently not available. Please try again later! "))
                    : (view.value.isTrial())
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_7, " End your free trial to download "))
                      : (view.value.isFree())
                        ? (_openBlock(), _createElementBlock("h1", _hoisted_8, " Downloads only for full subscribers "))
                        : (view.value.isPaidLimit())
                          ? (_openBlock(), _createElementBlock("h1", _hoisted_9, " Download limit reached "))
                          : (_openBlock(), _createElementBlock("h1", _hoisted_10, "Download summary")),
                  (view.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          (view.value.isFree())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "book-export__additional-info" }, " Downloading is only allowed for Shortform subscribers. ", -1)),
                                _cache[3] || (_cache[3] = _createElementVNode("p", null, " Please start a free trial to get access to content downloads. ", -1)),
                                _createElementVNode("div", _hoisted_14, [
                                  _cache[1] || (_cache[1] = _createElementVNode("img", {
                                    class: "book-export__start-trial-image",
                                    alt: "Subscribe",
                                    src: _imports_0
                                  }, null, -1)),
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("p", _hoisted_16, _toDisplayString(boxText.value), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_router_link, {
                                      class: "btns pdf-download__billing-link pdf-download__btn book-export__start-trial-button",
                                      to: { name: 'billing' }
                                    }, {
                                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                        _createTextVNode(" Start free trial ", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (view.value.isFreeCanDownload())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("p", _hoisted_18, [
                                  _cache[5] || (_cache[5] = _createTextVNode(" A free PDF summary of this book is available as a sample. This PDF is representative of the formatting quality we have for all of our PDF summaries. To access PDFs for all book summaries, ", -1)),
                                  _createVNode(_component_router_link, {
                                    to: { name: 'billing' },
                                    class: "pdf-download__billing-link"
                                  }, {
                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                      _createTextVNode("please sign up for a subscription", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[6] || (_cache[6] = _createTextVNode(". ", -1))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (view.value.isTrial())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("p", _hoisted_20, " Full subscribers get " + _toDisplayString(view.value.maxLimit()) + " new downloads every 7 days. ", 1),
                              (billing.value.supportsCancelTrial)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                                    _cache[7] || (_cache[7] = _createTextVNode(" You're currently in your free trial - please wait ", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(billing.value.daysUntilTrialEnd()), 1),
                                    _cache[8] || (_cache[8] = _createTextVNode(" for your free trial to finish. You can read and listen to all books in our app anytime. ", -1))
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_22, [
                                    _cache[9] || (_cache[9] = _createTextVNode(" You're currently in your trial - please wait ", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(billing.value.daysUntilTrialEnd()), 1),
                                    _cache[10] || (_cache[10] = _createTextVNode(" for your trial to finish or ", -1)),
                                    _createElementVNode("a", {
                                      class: "book-export__cancel-trial",
                                      onClick: showEndTrialPopup
                                    }, "End the trial now"),
                                    _cache[11] || (_cache[11] = _createTextVNode(". You can read and listen to all books in our app anytime. ", -1))
                                  ])),
                              _cache[12] || (_cache[12] = _createElementVNode("img", {
                                class: "book-export__download-image",
                                alt: "Free trial",
                                src: _imports_1
                              }, null, -1))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(BasePopup, {
                          ref_key: "popup",
                          ref: popup,
                          class: "book-preview",
                          title: "End Trial Period"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", { class: "popup__inner" }, [
                              _cache[13] || (_cache[13] = _createElementVNode("p", null, " When you press Confirm below, you'll immediately get full access to Shortform, including PDF downloads, and you'll be charged according to the billing plan you selected. ", -1)),
                              _createElementVNode("div", { class: "book-preview__footer" }, [
                                _createElementVNode("button", {
                                  class: "btns cancel-confirm",
                                  onClick: cancelTrial
                                }, " Confirm "),
                                _createElementVNode("button", {
                                  class: "btns btns--white cancel-cancel",
                                  onClick: hideEndTrialPopup
                                }, " Cancel ")
                              ])
                            ])
                          ]),
                          _: 1
                        }, 512),
                        (view.value.isTrialCanDownload())
                          ? (_openBlock(), _createElementBlock("p", _hoisted_23, " This PDF summary is available to download. "))
                          : _createCommentVNode("", true),
                        (view.value.isPaidDownloaded())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("p", _hoisted_25, " Full subscribers can access " + _toDisplayString(view.value.maxLimit()) + " new PDF downloads every 7 days. ", 1),
                              _cache[14] || (_cache[14] = _createElementVNode("p", { class: "book-export__additional-info" }, " You've previously accessed this PDF, so you can download it again without it counting toward your limit. ", -1))
                            ]))
                          : _createCommentVNode("", true),
                        (view.value.isPaidLimit())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createVNode(BookExportLimit, {
                                seconds: view.value.nextDownloadSeconds()
                              }, null, 8, ["seconds"])
                            ]))
                          : _createCommentVNode("", true),
                        (view.value.isPaidCanDownload())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("p", _hoisted_28, " Full subscribers can access " + _toDisplayString(view.value.maxLimit()) + " new PDF downloads every 7 days. ", 1),
                              _createElementVNode("div", _hoisted_29, [
                                _cache[15] || (_cache[15] = _createTextVNode(" You currently have ", -1)),
                                _createElementVNode("strong", null, _toDisplayString(view.value.remainingDownloadsText()), 1),
                                _cache[16] || (_cache[16] = _createTextVNode(" remaining. ", -1))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (view.value.canDownload())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              (view.value.isPaidDownloaded())
                                ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                                    _cache[18] || (_cache[18] = _createTextVNode(" A list of all your downloaded books is available on the ", -1)),
                                    _createVNode(_component_router_link, { to: {
                      name: 'bookSpecialListingPage',
                      params: { name: 'downloads' },
                    } }, {
                                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                        _createTextVNode("My Library", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[19] || (_cache[19] = _createTextVNode(" page. ", -1))
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("span", _hoisted_33, _toDisplayString(__props.doc.title), 1),
                                _createElementVNode("span", _hoisted_34, _toDisplayString(__props.doc.author), 1)
                              ]),
                              _createElementVNode("section", _hoisted_35, [
                                _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "book-export__action-title" }, [
                                  _createElementVNode("span", { class: "book-export__title-arrow iconfont iarrow" }),
                                  _createTextVNode("Download as PDF ")
                                ], -1)),
                                _cache[21] || (_cache[21] = _createElementVNode("p", { class: "book-export__action-description" }, " Opens well on most devices. Has additional formatting for readability. ", -1)),
                                _createVNode(PdfDownloadLink, {
                                  class: "pdf-download__button",
                                  book: __props.doc
                                }, null, 8, ["book"])
                              ]),
                              _createVNode(KindleExportForm, { book: __props.doc }, null, 8, ["book"]),
                              _cache[22] || (_cache[22] = _createElementVNode("section", { class: "book-export__disclaimer" }, [
                                _createElementVNode("strong", null, "Note"),
                                _createTextVNode(": This document is restricted to your personal use only. No part of this document may be reproduced or distributed other than for personal use, nor shared with individuals other than yourself, without prior written permission of Shortform Inc. ")
                              ], -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})